function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.0851 0.738508C6.91222 1.86375 0.538999 8.15265 0.538999 11.9318C0.538999 16.0842 3.92423 19.4621 8.0851 19.4621C12.246 19.4621 15.6312 16.0842 15.6312 11.9318C15.6312 8.15265 9.25798 1.86375 8.0851 0.738508M8.08511 20C3.62698 20 0 16.3806 0 11.9318C0 7.55749 7.57898 0.470107 7.90157 0.170508L8.08511 0L8.26864 0.170508C8.59123 0.470107 16.1702 7.55749 16.1702 11.9318C16.1702 16.3806 12.5432 20 8.08511 20",
  fill: "#6E6E6E"
});

var SvgOneDrop = function SvgOneDrop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOneDrop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/one-drop.62a3b03d.svg";
export { ForwardRef as ReactComponent };